let realtimeSseEnabled = true;

export function applyBootstrapRealtimeSettings(enabled: boolean): void {
  realtimeSseEnabled = enabled;
}

/**
 * When false, SSE hooks use snapshot GET fallback only (2s → 10s backoff).
 */
export function isRealtimeSseEnabled(): boolean {
  return realtimeSseEnabled;
}
